import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9ym98ftmh: FaireProductEntity = {
  token: "p_m9ym98ftmh",
  type: "product",
  name: "Weekly Desk Planner - Fully Known, Fully Loved",
  brandName: "Angle",
  imageUrl:
    "https://cdn.faire.com/fastly/0320d29243b86c384ba99477a410733dab0b8026120afde2f53af9825b2e0516.jpeg",
  priceDollars: 3.39,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ac295d9dc4b04606d44fa8e8fd677af4ff0115fbb918a9ea02f7a72a0eb87439.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
